import { formatCalendarDateForInput } from "../../../Utils/calendarDate.mjs";
import { courtTimeForInput, formatCourtTime, getActTime } from "../../../Utils/litigationDates.mjs";

const isTrue = (value) => value === true || value === "true";

const getEventType = (entry) => {
  if (entry.type === "TreatmentDates") return "Treatment Dates";

  const eventType = entry.event.event_type_id?.litigation_event_type;
  if (
    entry.type === "SOL" ||
    ["Statute of Limitations", "Statute Of Limitations", "S.O.L"].includes(eventType)
  ) {
    return "Statute of Limitations";
  }
  return eventType || "Other";
};

const getTime = (value) => {
  const clock = courtTimeForInput(value);
  if (!clock) return null;
  const [hours, minutes] = clock.split(":").map(Number);

  return {
    order: hours * 60 + minutes,
    label: formatCourtTime(clock),
  };
};

export const buildCaseTimelineSections = (timelineEvents) => {
  const days = new Map();

  (timelineEvents || []).forEach((group) => {
    (group.events || []).forEach((entry) => {
      if (!entry?.event || !["Litigation", "SOL", "TreatmentDates"].includes(entry.type)) {
        return;
      }

      const event = entry.event;
      const endpoint =
        (entry.type === "SOL" || isTrue(event.uses_end_date)) && event.end_date
          ? "end_date"
          : event.start_date
            ? "start_date"
            : "end_date";
      const endpointDate = event[endpoint];
      // Calendar entries are occurrences: a duration can appear on multiple days.
      // The event's own `date` is a creation timestamp for litigation and SOL acts.
      const occurrenceDate =
        entry.date || group.date || (entry.type === "TreatmentDates" ? event.date : endpointDate);
      const dateKey = formatCalendarDateForInput(occurrenceDate);
      if (!dateKey) return;

      const isDuration = isTrue(event.is_duration);
      const allDay = entry.type === "TreatmentDates" || isTrue(event.is_allday);
      const time = allDay
        ? null
        : getTime(getActTime(event, isDuration && event.start_date ? "start_date" : endpoint));
      const category = !time ? 0 : isDuration ? 2 : 1;
      const bucketKey = `${category}-${time?.order ?? 0}`;

      if (!days.has(dateKey)) days.set(dateKey, new Map());
      const buckets = days.get(dateKey);
      if (!buckets.has(bucketKey)) {
        buckets.set(bucketKey, {
          category,
          timeOrder: time?.order ?? 0,
          label: time?.label || "All Day",
          eventTypes: new Map(),
        });
      }

      const eventTypes = buckets.get(bucketKey).eventTypes;
      const eventType = getEventType(entry);
      if (!eventTypes.has(eventType)) eventTypes.set(eventType, []);
      eventTypes.get(eventType).push(entry);
    });
  });

  const sections = [];
  [...days.keys()].sort().forEach((dateKey, dayIndex) => {
    if (dayIndex > 0) sections.push({ type: "daySpacer", dateKey });

    const buckets = [...days.get(dateKey).values()].sort(
      (a, b) => a.category - b.category || a.timeOrder - b.timeOrder
    );
    buckets.forEach((bucket) => {
      sections.push({ type: "dateHeading", dateKey });
      sections.push({ type: "categoryLabel", label: bucket.label });
      bucket.eventTypes.forEach((entries, eventType) => {
        entries.forEach((entry) => {
          if (entry.type !== "TreatmentDates") {
            (entry.event.for_clients || []).forEach((client) => {
              sections.push({ type: "clientRow", entry, client });
            });
          }
          sections.push({ type: "eventTypeHeading", entry, eventType });
          sections.push({ type: "eventName", entry });
        });
      });
    });
  });
  return sections;
};
